import { useEffect, useState } from "react";
import { Square } from "lucide-react";
import { makeFrame } from "@/lib/geo";

import { tr } from "@/lib/i18n";
const EdgeInput = ({ i, len, active, gutter, onSet, onFocus }) => {
  const [v, setV] = useState(len.toFixed(2));
  useEffect(() => setV(len.toFixed(2)), [len]);
  const apply = () => { const n = Number(String(v).replace(",", ".")); if (n > 0 && Math.abs(n - len) > 0.004) onSet(i, n); else setV(len.toFixed(2)); };
  return (
    <label className={`flex items-center gap-2 rounded-md px-1.5 ${active ? "bg-sky-50 ring-1 ring-sky-300" : ""}`}>
      <span className="w-16 shrink-0 whitespace-nowrap text-xs font-tech text-slate-500">{gutter ? tr("Gronda") : tr("Lato {0}", [i + 1])}</span>
      <input value={v} data-testid={`editor-edge-${i}`} autoFocus={active} onFocus={onFocus}
        onChange={(e) => setV(e.target.value)} onBlur={apply} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
        className="flex-1 min-w-0 h-8 px-2 text-sm font-tech border border-slate-200 rounded-md outline-none focus:border-[#0F52BA]" />
      <span className="text-xs text-slate-400">m</span>
    </label>
  );
};

export const EdgeEditor = ({ roof, ed, setEdgeLength }) => {
  if (!roof || roof.polygon.length < 3) return null;
  const pm = roof.polygon.map(makeFrame(roof.polygon, 0).toUV);
  const lens = pm.map((a, i) => { const b = pm[(i + 1) % pm.length]; return Math.hypot(b[0] - a[0], b[1] - a[1]); });
  return (
    <div className="space-y-1.5" data-testid="editor-edge-list">
      {lens.map((l, i) => (
        <EdgeInput key={`${roof.id}-${i}`} i={i} len={l} gutter={i === (Number(roof.gutter_edge) || 0) % lens.length} active={ed.editEdge?.rid === roof.id && ed.editEdge?.i === i}
          onFocus={() => ed.setEditEdge({ rid: roof.id, i })} onSet={(j, n) => setEdgeLength(roof.id, j, n)} />
      ))}
      <p className="text-[11px] text-slate-400">{tr("Clic su una quota nel disegno per modificarla. I lati perpendicolari seguono la modifica.")}</p>
    </div>
  );
};

export const RectCreator = ({ onCreate }) => {
  const [w, setW] = useState("12");
  const [d, setD] = useState("8");
  return (
    <div className="flex items-end gap-1.5" data-testid="editor-rect-creator">
      <label className="flex-1"><span className="text-xs text-slate-500">{tr("Gronda")}</span>
        <input value={w} onChange={(e) => setW(e.target.value)} data-testid="editor-rect-w" className="w-full h-8 px-2 text-sm font-tech border border-slate-200 rounded-md" /></label>
      <span className="pb-1.5 text-slate-400">×</span>
      <label className="flex-1"><span className="text-xs text-slate-500">{tr("Falda")}</span>
        <input value={d} onChange={(e) => setD(e.target.value)} data-testid="editor-rect-d" className="w-full h-8 px-2 text-sm font-tech border border-slate-200 rounded-md" /></label>
      <button data-testid="editor-rect-create" title={tr("Crea rettangolo al centro della vista")}
        onClick={() => onCreate(Number(w.replace(",", ".")), Number(d.replace(",", ".")))}
        className="h-8 px-2.5 rounded-md bg-[#0F52BA] text-white text-sm flex items-center gap-1"><Square className="w-3.5 h-3.5" />{tr("Crea")}</button>
    </div>
  );
};
